export enum SettingsKey {
  INVENTORY_PICK_AND_PACK_ITEMS = 'inventory_pick_and_pack_items',
  QUICKBOOKS_ASSET_ACCOUNT = 'quickbooks_asset_account',
  QUICKBOOKS_EXPENSE_ACCOUNT = 'quickbooks_expense_account',
  QUICKBOOKS_INCOME_ACCOUNT = 'quickbooks_income_account',
  QUICKBOOKS_AP_ACCOUNT = 'quickbooks_ap_account',
  QUICKBOOKS_ALLOW_ACH = 'quickbooks_allow_ach',
  QUICKBOOKS_ALLOW_CC = 'quickbooks_allow_cc',
  QUICKBOOKS_SYNC = 'quickbooks_sync',
  QUICKBOOKS_ACCOUNTS = 'quickbooks_accounts',
  ON_OFF_QUOTATIONS = 'on_off_quotations',
  DEFAULT_WAREHOUSE_GROUP_ID = 'default_warehouse_group_id',
  SHOW_SUPPLIER_PO_SOURCE_SKU = 'show_supplier_po_source_sku',
  SHOW_SUPPLIER_PO_DESCRIPTION = 'show_supplier_po_description',
  INVOICE_ALLOW_COMPLETED_TO_ACTIVE = 'invoice_allow_completed_to_active',
  QUICKBOOKS_PO_SYNC = 'quickbooks_po_sync',
  PURCHASE_ORDER_SETTINGS = 'purchase_order_settings',
  PURCHASE_ORDER_EMAIL_CONTENT = 'po_email_content',
  COST_ALLOCATION_TYPE = 'cost_allocation_type',
  ENABLE_UNFULFILLABLE_STOCKS_TRACKING = 'enable_unfulfillable_stocks_tracking',
  PAYMENT_GATEWAY = 'payment_gateway',
  COSTING_TYPE = 'costing_type',
  REBUILD_COST_LAYERS_NIGHTLY = 'rebuild_cost_layers_nightly',
  SHIPMENT_BASED_COST_LAYERS = 'shipment_based_cost_layers',
}

export const CNotificationTimeValues = [
  {
    label: '12:00 AM',
    value: '00:00',
  },
  {
    label: '01:00 AM',
    value: '01:00',
  },
  {
    label: '02:00 AM',
    value: '02:00',
  },
  {
    label: '03:00 AM',
    value: '03:00',
  },
  {
    label: '04:00 AM',
    value: '04:00',
  },
  {
    label: '05:00 AM',
    value: '05:00',
  },
  {
    label: '06:00 AM',
    value: '06:00',
  },
  {
    label: '07:00 AM',
    value: '07:00',
  },
  {
    label: '08:00 AM',
    value: '08:00',
  },
  {
    label: '09:00 AM',
    value: '09:00',
  },
  {
    label: '10:00 AM',
    value: '10:00',
  },
  {
    label: '11:00 AM',
    value: '11:00',
  },
  {
    label: '12:00 PM',
    value: '12:00',
  },
  {
    label: '01:00 PM',
    value: '13:00',
  },
  {
    label: '02:00 PM',
    value: '14:00',
  },
  {
    label: '03:00 PM',
    value: '15:00',
  },
  {
    label: '04:00 PM',
    value: '16:00',
  },
  {
    label: '05:00 PM',
    value: '17:00',
  },
  {
    label: '06:00 PM',
    value: '18:00',
  },
  {
    label: '07:00 PM',
    value: '19:00',
  },
  {
    label: '08:00 PM',
    value: '20:00',
  },
  {
    label: '09:00 PM',
    value: '21:00',
  },
  {
    label: '10:00 PM',
    value: '22:00',
  },
  {
    label: '11:00 PM',
    value: '23:00',
  },
];

export enum CostAllocationTypeConstants {
  UNIT_BASED_ALLOCATION = 'UNIT_BASED_ALLOCATION',
  VOLUME_BASED_ALLOCATION = 'VOLUME_BASED_ALLOCATION',
  WEIGHT_BASED_ALLOCATION = 'WEIGHT_BASED_ALLOCATION',
  VALUE_BASED_ALLOCATION = 'VALUE_BASED_ALLOCATION',
}

export const COST_ALLOCATION_TYPES = [
  { value: 'UNIT_BASED_ALLOCATION', label: 'UNIT_BASED_ALLOCATION' },
  { value: 'VOLUME_BASED_ALLOCATION', label: 'VOLUME_BASED_ALLOCATION' },
  { value: 'WEIGHT_BASED_ALLOCATION', label: 'WEIGHT_BASED_ALLOCATION' },
  { value: 'VALUE_BASED_ALLOCATION', label: 'VALUE_BASED_ALLOCATION' },
];

export enum EExtraCosts {
  SHIPPING_COST = 'Shipping Cost',
}
